export { WizardComponent } from './wizard.component';
export { WizardCompletionStepComponent } from './wizard-completion-step.component';
export { WizardNavigationBarComponent } from './wizard-navigation-bar.component';
export { WizardStepComponent } from './wizard-step.component';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/~/ng2-archwizard/dist/components/index.js
// module id = ../../../../ng2-archwizard/dist/components/index.js
// module chunks = 3